import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { reportingService } from 'src/app/core/services/reporting.service';
import { SettingService } from 'src/app/core/services/setting.service';
import { LoadingState } from '../../loading/loading.component';

@Component({
  selector: 'app-weekly-progress',
  templateUrl: './weekly-progress.component.html',
  styleUrls: ['./weekly-progress.component.scss']
})
export class WeeklyProgressComponent implements OnInit {

  loading: LoadingState = LoadingState.NotReady;
  form: FormGroup;
  @Input() sitearr: any = [];
  @Input() unitarr: any = [];
  @Input() progressDetailsData: any;
  @Input() projectList: any = [];
  @Input() boqList: any = [];
  @Input() activityList: any = [];
  @Output() setDetailsData = new EventEmitter<any>();
  @Output() setSiteData = new EventEmitter<any>();
  @Output() setBoqData = new EventEmitter<any>();
  start_date: any = null;
  end_date:any = null;
  dateRange: any = [];
  boqDescription = null;

  constructor(private formBuilder: FormBuilder, private settingService: SettingService,
    public reportService: reportingService,
    private toastr: ToastrService,) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      project_id: [null, Validators.required],
      site_location: [null, Validators.required],
      date_range: [null],
      boq: ['', Validators.required],
      progress_data: this.formBuilder.array([this.addProgressDataFormGroup()])
    });

    if (this.progressDetailsData == undefined) {
      this.progressDetailsData = {
        project_id: null,
        site_location: null,
        start_date: null,
        end_date: null,
        boq: ''
      }
    }
    this.loading = LoadingState.Ready;
  }

  dateTimeReset(){
    this.dateRange = null;
  }

  addProgressDataFormGroup(): FormGroup {
    return this.formBuilder.group({
      activity_id: [null, Validators.required],
      description: [''],
      uom_id: [null, Validators.required],
      quantity: ['', Validators.required],
    });
  }

  removeProgressDataFormGroup(index) {
    const control = <FormArray>this.form.controls['progress_data'];
    control.removeAt(index);
  }

  addButtonClick(): void {
    const control = <FormArray>this.form.controls['progress_data'];
    control.push(this.addProgressDataFormGroup());
  }
  
  getFormArrayControl(form) {
    return form.get('progress_data').controls
  }

  onDateSelected() {
    if (this.start_date != null) {
      this.setDetailsData.emit(this.progressDetailsData)
      if (this.progressDetailsData.site_location != null && this.progressDetailsData.project_id != null) {
        this.reportService.fetchWeeklyCommonData(this.progressDetailsData.project_id, this.progressDetailsData.site_location,this.start_date, this.end_date, 1).subscribe(
          res => {
            //console.log(res)
            if (res['result'] != '') {
              this.progressDetailsData.boq = res['result']['boq'];
              this.onBOQSelection(this.progressDetailsData.boq);
            }
            else {
              this.progressDetailsData.boq = null;
              this.boqDescription = '';
            }
            this.setDetailsData.emit(this.progressDetailsData)
          },
          error => {
            //console.log(error)
          }
        )
      }
    }

  }

  markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        control.controls.forEach(c => this.markFormGroupTouched(c));
      }
    });
  }

  progressSiteOnchange(val) {
    this.setSiteData.emit(val);
  }

  progressProjectOnChange(val) {
    this.setBoqData.emit(val);
  }

  isFieldValid(form: FormGroup, field: string) {
    return !form.get(field).valid && (form.get(field).dirty || form.get(field).touched);
  }

  displayFieldCss(form: FormGroup, field: string) {
    return {
      'is-invalid': form.get(field).invalid && (form.get(field).dirty || form.get(field).touched),
      'is-valid': form.get(field).valid && (form.get(field).dirty || form.get(field).touched)
    };
  }

  formatHandler(event) {
    if (event.value[0] != null) {
      this.start_date = this.settingService.formatDate(event.value[0])
      this.end_date = this.settingService.formatDate(event.value[1])
      this.onDateSelected();
    }
  }

  savedata() {
    if (this.form.valid && this.start_date != null && this.end_date != null) {
      this.loading = LoadingState.Processing
      const formData: any = new FormData();
      formData.append('type_of_report', '1');
      formData.append('project_id', this.form.value.project_id);
      formData.append('site_location', this.form.value.site_location);
      formData.append('boq', this.form.value.boq);
      formData.append('start_date',this.start_date);
      formData.append('end_date',this.end_date);
      var progress_data = [];
      this.form.value.progress_data.forEach(x => {
        progress_data.push({
          activity_id: x.activity_id,
          description: x.description,
          uom_id: x.uom_id,
          approx_qty_planned_for_the_week: x.quantity
        })
      });
      formData.append('progress_data', JSON.stringify(progress_data));
      this.reportService.saveWeeklyProgressData(formData).subscribe(
        data => {
          var res: any = data;
          this.toastr.success('Data has been succesfully saved !', '', {
            timeOut: 3000,
          });
          var objData = Object.assign([], this.form.value.progress_data)
          for (var i = objData.length - 1; i >= 0; i--) {
            this.removeProgressDataFormGroup(i)
          }
          this.addButtonClick()
          this.loading = LoadingState.Ready;
          this.form.reset();
          this.boqDescription = '';
        },
        error => {
          this.toastr.error('Internal error occurred !', '', {
            timeOut: 3000,
          });
          this.loading = LoadingState.Ready
        }
      );
    }
    else {
      this.markFormGroupTouched(this.form);
    }
  }

  onBOQSelection(val) {
    if(val) {
      this.boqDescription = this.boqList.filter(x => x.id == val)[0]['item_description'];
    } else {
      this.boqDescription = null
    }
  }
}
